module.exports = __webpack_public_path__ + "static/media/Cyrkulacja.218a995f.svg";